<template>
    <div class="min-h-full flex items-center justify-center mt-12">
        <div class="container-padded w-2/5 space-y-8 shadow-md sm:p-12">
            <h2 class="text-center mb-4">
                Go Premium
            </h2>
            <form @submit.prevent="checkout" class="space-y-6">
                <div class="flex rounded-md grid grid-cols-2 justify-center w-1/2">
                    <div class="inline-flex rounded-md justify-center">
                        <input type="radio" v-model="term" value="premium_monthly" id="Monthly" name="monthlyOrYearly" checked style="visibility:hidden"
                               @change="changeTerm" />
                        <label for="Monthly" class="radio text-center self-center py-2 px-4 rounded-md cursor-pointer hover:opacity-75 border-salesium-grey-100 border-2">Monthly ($99)</label>
                    </div>
                    <div class="inline-flex rounded-md justify-center">
                        <input type="radio" v-model="term" value="premium_yearly" id="Yearly" name="monthlyOrYearly" style="visibility:hidden"
                               @change="changeTerm" />
                        <label for="Yearly" class="radio text-center self-center py-2 px-4 rounded-md cursor-pointer hover:opacity-75 border-salesium-grey-100 border-2">Yearly ($990)</label>
                    </div>
                </div>

                <div id="payment-element"/>
                <div v-if="!this.user.business_location.address1">
                    <div>
                        <t-checkbox name="saveAddress" v-model="saveAddress"/>
                        Save address as Business Location in Salesium
                    </div>
                    <div>
                        <t-checkbox name="walkinsWelcome" v-model="walkinsWelcome"/>
                        Walkins Welcome
                    </div>
                </div>
                <div id="address-element"/>
                <button type="submit"
                        class="primary-btn mt-14 px-12"
                        :disabled="submitting">
                    Checkout
                </button>
                <div id="error-message">
                    <t-alert variant="danger" :show="showError" class="mt-3">
                        {{ errorMessage }}
                    </t-alert>
                </div>
            </form>
        </div>
    </div>

</template>

<script>
import ProFeatures from './ProFeatures.vue';
import {loadScript} from "vue-plugin-load-script";
import Vue from "vue";

export default {
    data() {
        return {
            submitting: false,
            errorMessage: '',
            showError: false,
            stripe: null,
            stripeElements: null,
            paymentElement: null,
            stripeKey: '',
            stripeSecret: '',
            stripeClientSecret: '',
            setupResult: null,
            addressElement: null,
            savePayment: false,
            saveAddress: false,
            prefillAddress: {
                line1: this.user.business_location && this.user.business_location.address1
                    ? this.user.business_location.address1
                    : '',
                line2: this.user.business_location && this.user.business_location.address2
                    ? this.user.business_location.address2
                    : '',
                city: this.user.business_location && this.user.business_location.city
                    ? this.user.business_location.city
                    : '',
                state: this.user.business_location && this.user.business_location.state_province
                    ? this.user.business_location.state_province
                    : '',
                postal_code: this.user.business_location && this.user.business_location.postal_code
                    ? this.user.business_location.postal_code
                    : '',
                country: 'US',
            },
            updatedAddress: {
                address1: '',
                address2: '',
                city: '',
                state_province: '',
                postal_code: '',
                country: '',
            },
            walkinsWelcome: this.user.walkins_welcome === null ? false : this.user.walkins_welcome,
            term: 'premium_monthly',
        }
    },
    props: ["user", "intent"],
    methods: {
        async checkout() {
            this.submitting = true;
            this.showError = false;
            await this.stripeElements.submit();
            await this.stripe.confirmSetup({
                elements: this.stripeElements,
                clientSecret: this.stripeClientSecret,
                redirect: "if_required",
                confirmParams: {
                    return_url: 'https://' + window.location.host
                } //+ '/storefront/' + this.user.username }
            }).then((result) => {
                this.setupResult = result;
            });
            if (this.setupResult.error) {
                console.log(this.setupResult.error.code);
                console.log(this.setupResult.error.message);
                this.errorMessage = this.setupResult.error.message;
                this.showError = true;
                this.submitting = false;
            } else {
                console.log( this.updatedAddress.address1);
                const params = new URLSearchParams();
                params.append('paymentMethodId', this.setupResult.setupIntent.payment_method);
                params.append( 'term', this.term);
                if (this.updatedAddress && this.saveAddress) {
                    params.append('address', JSON.stringify( this.updatedAddress));
                    params.append('walkinsWelcome', this.walkinsWelcome);
                }
//                console.log(params);
                // TODO premium subscribe currently only returns 200 ok.
                // need to plan for other values
                axios.post('/api/user/premium-subscribe', params)
                    .then( (response) => {
                        Vue.toasted.success(
                            'Successfully signed up for Premium',
                            {
                                duration: 5000, // milliseconds
                                position: "top-center"
                            });
                        window.location.href = '/';
                    })
                    .catch((error) => {
                        this.submitting = false;
                        console.log(error);
                    });
            }
        },
        onAddressChange(event) {
            if (event.complete) {
                this.updatedAddress.address1 = event.value.address.line1;
                this.updatedAddress.address2 = event.value.address.line2;
                this.updatedAddress.city = event.value.address.city;
                this.updatedAddress.state_province = event.value.address.state;
                this.updatedAddress.postal_code = event.value.address.postal_code;
                this.updatedAddress.country = event.value.address.country;
                console.log( JSON.stringify( this.updatedAddress));
            }
        },
        changeTerm() {
            console.log( this.term);
        },
    },
    created() {

    },
    mounted() {
        console.log( this.user);
        loadScript("https://js.stripe.com/v3/")
            .then(() => {
//                console.log( this.intent);
                this.stripe = Stripe(process.env.MIX_STRIPE_KEY);
                this.stripeClientSecret = this.intent.client_secret;

                const elementOptions = {clientSecret: this.stripeClientSecret};
                this.stripeElements = this.stripe.elements(elementOptions);

                const paymentLayout = {
                    type: 'accordion',
                    defaultCollapsed: false,
                    radios: false,
                    spacedAccordionItems: false
                };
                const paymentOptions = {
//                    mode: 'subscription',
//                    amount: 9900,
//                    currency: 'usd',
//                    appearance: {},
                    layout: paymentLayout
                };

                this.paymentElement = this.stripeElements.create('payment', paymentOptions);
                this.paymentElement.mount('#payment-element');

                const addressOptions = {
                    mode: 'billing',
                    defaultValues: {
                        name: this.user.display_name,
                        address: this.prefillAddress
                    }
                };

                this.addressElement = this.stripeElements.create('address', addressOptions);
                this.addressElement.on('change', this.onAddressChange);
                this.addressElement.mount('#address-element');
            })
            .catch((error) => {
                console.log('load failed');
                console.log(error);
            });
    },
    components: {
        ProFeatures
    }
};
</script>

<style scoped>
.animation-in {
    transform-origin: left;
    animation: in 0.6s ease-in-out;
}

.animation-out {
    transform-origin: bottom left;
    animation: out 0.6s ease-in-out;
}
</style>
